export default {
  registrosPorPagina: 50
}
